module.exports = __webpack_public_path__ + "static/media/judiciaire.797cc24b.png";